import { UserProfile } from '@/__generated_graphql__/graphql';
import { PROFILE_MODES, ProfileMode } from '@/constants/common';

export type ProfileProps = {
  isCandidate: boolean | null;
  isCompany: boolean | null;
  isBoth: boolean | null;
  image: string | null;
  name: string | null;
};

export type UserProfileType = UserProfile | undefined;

export class ProfileFormatter {
  static getProfileName(
    profile: UserProfileType,
    profileMode: ProfileMode | null
  ): string | null {
    if (!profile) return null;

    return profileMode === PROFILE_MODES.COMPANY
      ? this.getCompanyName(profile)
      : this.getCandidateName(profile);
  }

  static isProfileCandidate(profile: UserProfileType): boolean | null {
    if (!profile) return null;
    return profile?.candidate !== null;
  }

  static isProfileCompany(profile: UserProfileType): boolean | null {
    if (!profile) return null;
    return profile?.company !== null;
  }

  static isProfileBoth(profile: UserProfileType): boolean | null {
    if (!profile) return null;
    return profile?.company !== null && profile?.candidate !== null;
  }

  static getCompanyName(profile: UserProfileType): string | null {
    if (!profile || !profile.company) return null;
    return profile.company.name ?? null;
  }

  static getCandidateName(profile: UserProfileType): string | null {
    if (!profile || !profile.candidate) return null;
    return [profile.candidate.firstName, profile.candidate.surname]
      .filter(Boolean)
      .join(' ');
  }

  static getCompanyImage(profile: UserProfileType): string | null {
    if (!profile || !profile.company) return null;
    return profile.company.logoUrl ?? null;
  }

  static getCandidateImage(profile: UserProfileType): string | null {
    if (!profile || !profile.candidate) return null;
    return profile.candidate.logoUrl ?? null;
  }

  static getProfileProps(
    profile: UserProfileType,
    profileMode: ProfileMode | null
  ): ProfileProps {
    return {
      isCandidate: this.isProfileCandidate(profile),
      isCompany: this.isProfileCompany(profile),
      isBoth: this.isProfileBoth(profile),
      image:
        profileMode === PROFILE_MODES.COMPANY
          ? this.getCompanyImage(profile)
          : this.getCandidateImage(profile),
      name:
        profileMode === PROFILE_MODES.COMPANY
          ? this.getCompanyName(profile)
          : this.getCandidateName(profile)
    };
  }
}
